export default {
    ADULT: 'Adult',
    CHILD: 'Child',
    INFANT: 'Infant',
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/traveller-types.js